import React from 'react';

export const MoveLeftIcon = props => {
  return (
    <svg viewBox='0 0 40 40' {...props}>
      <defs>
        <clipPath id='prefix__a'>
          <path d='M0 0h40v40H0z' />
        </clipPath>
      </defs>
      <g clipPath='url(#prefix__a)'>
        <path
          data-name='\u30D1\u30B9 1187'
          d='M33.419 6.581A18.3 18.3 0 0020 1 18.3 18.3 0 006.582 6.581 18.3 18.3 0 001.001 20a18.3 18.3 0 005.581 13.419A18.3 18.3 0 0020.001 39a18.3 18.3 0 0013.418-5.581A18.3 18.3 0 0039 20a18.3 18.3 0 00-5.581-13.419zm-1.781 25.056a15.862 15.862 0 01-11.637 4.83 15.862 15.862 0 01-11.638-4.83A15.862 15.862 0 013.534 20 15.862 15.862 0 018.363 8.362 15.862 15.862 0 0120 3.533a15.862 15.862 0 0111.638 4.829A15.862 15.862 0 0136.467 20a15.862 15.862 0 01-4.829 11.637zM23.326 11.45a1.435 1.435 0 00-1.979 0l-9.817 7.758a.939.939 0 00-.4.752 1.173 1.173 0 00.4.831h.083l9.738 7.758a1.552 1.552 0 001.979 0l.079-.079a.975.975 0 00.4-.792V12.242a.93.93 0 00-.483-.792z'
        />
      </g>
    </svg>
  );
};



// WEBPACK FOOTER //
// ./src/components/icons/MoveLeftIcon.jsx